import React from "react";
import "./ProgressBar.scss";

const ProgressBar = ({ currentPage, hideBar = false }) => {
	const fillPct = currentPage >= 2 ? 100 : 50;
	const stepLabel = currentPage >= 2 ? "Step 02" : "Step 01";
	const stepLabel2 =
		currentPage >= 2 ? "RETAILER INFORMATION" : "BUILD YOUR PROGRAM";
	const stepLabel3 =
		currentPage >= 2
			? "Confirm your retailer details and submit your program enrollment."
			: "Select the services you want to activate and assign a monthly budget to each. You can adjust at any time before submitting.";
	const stepLabel4 =
		currentPage >= 2
			? "Constellation will reach out within 24 hours to complete activation."
			: "";
	return (
		<div
			className={`progress-bar-root${
				currentPage === 2 ? " progress-bar-root--page-two" : ""
			}`}>
			{!hideBar && (
				<div className="progress-bar-container">
					<div className="progress-labels">
						<div className="progress-label-col">
							<span
								className={`progress-step-text ${
									currentPage === 1 ? "is-active" : ""
								} ${currentPage > 1 ? "is-complete" : ""}`}>
								1. YOUR PROGRAM
							</span>
						</div>
						<div className="progress-label-col">
							<span
								className={`progress-step-text ${
									currentPage >= 2 ? "is-active" : ""
								}`}>
								2. RETAILER INFORMATION
							</span>
						</div>
					</div>
					<div className="progress-track" aria-hidden="true">
						<div
							className="progress-track-fill"
							style={{ width: `${fillPct}%` }}
						/>
					</div>
				</div>
			)}
			<div
				className={`progress-bar-step-caption${
					currentPage === 2
						? " progress-bar-step-caption--page-two"
						: ""
				}${hideBar ? " progress-bar-step-caption--compact" : ""}`}
				aria-live="polite">
				<p className="progress-bar-step-caption-label1">{stepLabel}</p>
				<p className="progress-bar-step-caption-label2">{stepLabel2}</p>
				<p className="progress-bar-step-caption-label3">{stepLabel3}</p>
				<p className="progress-bar-step-caption-label4">{stepLabel4}</p>
			</div>
		</div>
	);
};

export default ProgressBar;
